import Post from '../../interfaces/Post.interface';

const postVariablesToFormVariables = (post: Post): Post => {
  const imageFormVariables = post.variables && post.variables
    .filter(v => v.type === 'text')
    .map(v => ({
      id: v.id.replace('.', '__'),
      originalId: v.id,
      name: v.id.split('.').pop(),
      type: v.type,
      value: v.value,
      originalValue: v.value,
      maxLength: v.maxLength,
    }))
    .sort((a, b) => a.name.localeCompare(b));
  return {
    ...post,
    imageFormVariables,
  };
};

export default postVariablesToFormVariables;
